import { render, staticRenderFns } from "./PunchTagTable.vue?vue&type=template&id=349f9e16"
import script from "./PunchTagTable.vue?vue&type=script&lang=ts"
export * from "./PunchTagTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports